import styled from 'styled-components';

export default styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	min-height: 0;
	flex: 1;

	.motif-progress-loader {
		position: absolute;
		left: 50%;
		transform: translateX(-50%);
	}

	&.spacing-none > .motif-progress-loader {
		top: 50%;
		transform: translate(-50%, -50%);
	}
	&.spacing-sm > .motif-progress-loader {
		top: var(--px-80);
	}
	&.spacing-md > .motif-progress-loader {
		top: var(--px-160);
	}

	&.loading {
		& > *:not(.motif-progress-loader) {
			opacity: 0.5;
			pointer-events: none;
		}
		&.block > *:not(.motif-progress-loader) {
			opacity: 0;
			pointer-events: none;
		}
	}

	.motif-form-field {
		position: relative;
		.motif-error-message {
			position: absolute;
			top: 100%;
		}
	}
`;
